module.exports = __webpack_public_path__ + "static/media/donkimpat68.6a6b9c0e.png";